import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { goBack, push } from 'connected-react-router'
import { withTranslation } from 'react-i18next'

import { ISectionHeaderIndexProps } from './interface'

import SectionHeader from './SectionHeader'

const mapDispatchToProps = {
  goBack,
  push,
}

// @ts-ignore
export default connect(null, mapDispatchToProps)(withRouter(withTranslation()(SectionHeader))) as React.FC<
  ISectionHeaderIndexProps
>
